import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { useCartDetails } from 'hb-redux-store/feature/cart/cart.hooks';
import { getDeviceType } from 'hb-redux-store/util/DeviceDetectionService';
import { DEVICE_TYPE } from 'hb-redux-store/util/constantServices';
import { OKAY_TEXT } from 'hb-redux-store/feature/cart/cart.constant';

import Modal from 'components/mweb/Modal/Modal';
import ScratchCard from 'components/mweb/ScratchCard/index';

import './modal.scss';

function ScratchModal({ scratchCardModal = {}, onCancel = () => {} }) {
  const [showInfo, setShowInfo] = useState(false);
  const { scratchCard } = useCartDetails();
  const isMobileDevice = getDeviceType() === DEVICE_TYPE.MWEB;
  const scratchCardSize = isMobileDevice ? 300 : 400;
  const handleOnCancel = () => {
    onCancel();
    setShowInfo(false);
  };

  return (
    <Modal
      visible={scratchCardModal?.visible}
      onCancel={handleOnCancel}
      footer={null}
      centered={true}
      destroyOnClose={true}
      closable={false}
      wrapClassName="scratch-card-modal"
      zIndex={1050}
    >
      <ScratchCard
        foregroundImage={scratchCardModal?.data?.foregroundUrl}
        backgroundImage={scratchCardModal?.data?.backgroundUrl}
        completeAt={60}
        width={scratchCardSize}
        height={scratchCardSize}
        onComplete={() => {
          const payload = {
            promotionId: scratchCardModal?.data?.id,
            scratched: true,
          };
          scratchCard(payload);
          setShowInfo(true);
        }}
        zIndex={1050}
      >
        <>
          <img
            src={scratchCardModal?.data?.backgroundUrl}
            className="hb-modal scratch-card-modal--image"
          />
          {showInfo && (
            <div className="hb-modal scratch-card-modal--message-box ">
              <div className="hb-modal scratch-card-modal--sub-container">
                <div>
                  <span>{scratchCardModal?.data?.infoText}</span>
                  {scratchCardModal?.data?.tncLink &&
                    scratchCardModal?.data?.tncText && (
                      <Link
                        className="hb-modal scratch-card-modal--tnc-text"
                        onClick={handleOnCancel}
                        to={{ pathname: scratchCardModal?.data?.tncLink }}
                        target="_blank"
                      >
                        {scratchCardModal?.data?.tncText}
                      </Link>
                    )}
                </div>
                <div
                  className="hb-modal scratch-card-modal--button-text"
                  onClick={handleOnCancel}
                >
                  {OKAY_TEXT}
                </div>
              </div>
            </div>
          )}
        </>
      </ScratchCard>
    </Modal>
  );
}

ScratchModal.propTypes = {
  scratchCardModal: PropTypes.object,
  onCancel: PropTypes.func,
};

export default ScratchModal;
